<template>
    <div id="konfigurator-hotove-krmivo">
        <h1>A je to! {{ mazlicek.jmeno.value }} má svůj vlastní Pettime</h1>

        <div v-if="additional_info_header" class="summary-subtitle">
            <div v-html="additional_info_header.content"></div>
        </div>

        <!-- <div class="checklist-rasa" v-if="mazlicek.rasa.typ === 'app_rasa'">{{ mazlicekRasa.autocomplete.keyword
             }}
         </div>
         <div class="checklist-rasa" v-else-if="mazlicek.rasa.typ == 'app_velikost'">
             {{ velikost.title
             }}
         </div> -->

        <div v-if="grandTexts" class="view-co-prinasi-krmivo-navic">
            <div v-if="grandTexts['pet-live'] && grandTexts['pet-live'].text_1" class="views-row">

                <div class="views-field-field-krmivo-co-prinasi zivot" v-html="grandTexts['pet-live'].text_1"></div>
            </div>
            <div v-if="grandTexts['pet-live'] && grandTexts['pet-live'].text_2" class="views-row">
                <div class="views-field-field-krmivo-co-prinasi zivot" v-html="grandTexts['pet-live'].text_2"></div>
            </div>
            <div v-if="grandTexts['pet-bread'] &&
            grandTexts['pet-bread'].text" class="views-row">
                <div class="views-field-field-krmivo-co-prinasi rasa" v-html="grandTexts['pet-bread'].text"></div>
            </div>
            <div v-if="grandTexts['pet-alergic'] && grandTexts['pet-alergic'].text" class="views-row">
                <div class="views-field-field-krmivo-co-prinasi alergie" v-html="grandTexts['pet-alergic'].text"></div>
            </div>
        </div>
        <div id="block-views-modelovy-pes-krmna-davka-block" class="block block-views contextual-links-region">
            <h2>Denní dávka</h2>
            <div class="content">
                <div
                    class="view view-modelovy-pes-krmna-davka view-id-modelovy_pes_krmna_davka view-display-id-block view-dom-id-33c75cace5282ecc90658493756f026b">
                    <div class="view-content">
                        <div class="views-row views-row-1 views-row-odd views-row-first views-row-last">
                            <div class="views-field views-field-field-model-krmna-davka">
                                <div v-if="isDataLoading" class="field-content">
                                    <!--<p>Průměrná denní krmná dávka je {{ round(weightFeedRatio)-->
                                    <!--}} g / {{ round((weightFeedRatio * 0.03527396195) * 10 | round) / 10-->
                                    <!--}} oz. Denní energetický příjem je {{ round(feedData.feedRatio.energyRatio)-->
                                    <!--}} kcal.-->
                                    <!--</p>-->
                                    <div class="krmna-davka-item">
                                        <div><span>Denní dávka</span></div>
                                        <div><span>{{ round(weightFeedRatio) }} g / {{ round((weightFeedRatio * 0.03527396195) * 10 | round) / 10 }} oz</span>
                                        </div>
                                    </div>
                                    <div class="krmna-davka-item">
                                        <div><span>Denní energetický příjem</span></div>
                                        <div>
                                            <span>{{ round(energyRatio * 4.184) }} kJ / {{ round(energyRatio) }} kcal</span>
                                        </div>
                                    </div>
                                    <div v-if="showTotalPrice" class="krmna-davka-item krmna-davka-item-cena">
                                        <div><span><span>Cena denní dávky</span><span>při objednávce na {{ $store.state.mazlicek.krmivo.tydny.value }} {{ weeksReadableValue }}</span></span>
                                        </div>
                                        <div><span>{{ (pricePerDay + '').replace('.', ',') }} Kč</span></div>
                                    </div>
                                    <p v-if="individualFeedWeight">
                                        <strong>Váš pes má individuální krmnou dávku nastavenou na {{
                                            individualFeedWeight * 100 }}% vypočtené dávky.</strong></p>
                                    <div v-if="dailyCostText" class="krmna-davka-kafe">
                                        <span><img :src="dailyCostText.uri"></span>
                                        <span>{{dailyCostText.text_1}} {{dailyCostText.text_2}}</span>
                                    </div>
                                </div>
                                <div v-else>
                                    <p>Načítaní...</p>
                                </div>
                                <ul v-if="mazlicek.krmivo.feedData && mazlicek.jeStene">
                                    <li :key="key" v-for="(value, key) in mazlicek.krmivo.feedData.feedRatio.puppyInfo">
                                        Týden: {{ key + 1 }} / Dospělost: {{ value.puppyStep }} %
                                        <ul>
                                            <li>Energický koeficient: {{ value.energyCoefficient }} %</li>
                                            <li>Energie krmné dávky: {{ value.energyRatio }} kj</li>
                                            <li>Váha: {{ value.weight }} kg</li>
                                            <li>Váha krmné dávky: {{ value.weightFeedRatio }} g</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="$store.state.mazlicek.krmivo.tydny.value !== 0"
                                 class="views-field views-field-field-model-krmna-davka-upozorne">
                                <span class="field-content" v-if="!mazlicek.jeStene" v-html="hmotnostFinalText"></span>
                                <span class="field-content" v-if="!mazlicek.jeStene" v-html="pohybFinalText"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div v-if="$store.state.mazlicek.krmivo.tydny.value !== 0" id="block-views-fdcf5c69a8fa9141ff5628a9145c15a0"-->
        <!--class="block block-views contextual-links-region">-->
        <!--<div class="content">-->
        <!--<div-->
        <!--class="view view-modelovy-pes-krmna-davka-podrobnosti view-id-modelovy_pes_krmna_davka_podrobnosti view-display-id-block view-dom-id-11dd62fd9b7eeb0ffe723f601906fc7a">-->
        <!--<div class="view-header" v-if="tabsOpen['3']" @click="changeTabsState(3)">-->
        <!--<div class="show-more">Zobrazit podrobnosti o krmné dávce</div>-->
        <!--</div>-->
        <!--<div class="view-content" v-else>-->
        <!--<span class="konfigurator-info-close" @click.stop="changeTabsState(3)"></span>-->
        <!--<div class="views-row views-row-1 views-row-odd views-row-first views-row-last">-->

        <!--<div class="views-field views-field-field-model-krmna-davka-podrobno">-->
        <!--<div class="field-content">-->
        <!--<h2>{{ finalTexts[3].title }}</h2>-->
        <!--<div v-html="finalTexts[3].description"></div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <div id="block-views-a32ab1e314a9dc8bd354141155fe7218" class="block block-views contextual-links-region">
            <h2>Složení</h2>
            <div class="summary-subtitle">Skvělý výběr</div>
            <div class="content">
                <div class="slozky">
                    <div class="slozka-item slozka-masova">
                        <div class="slozka-item-inner">
                            <div class="slozka-icn">
                                <img :src="getIconUrlById(slozky.masova.id, 'png')" width="60" height="60"/>
                            </div>
                            <div class="slozka-nadpis" v-html="slozky.masova.title"></div>
                            <div class="slozka-popis" v-html="slozky.masova.description"></div>
                        </div>
                    </div>
                    <div v-for="(addition, key) in selectedAdditionsBlocks" :key="key" class="slozka-item topping">
                        <div class="slozka-item-inner">
                            <div class="slozka-icn">
                                <img :src="getIconUrlById(addition.id)" width="60" height="60"/>
                            </div>
                            <div class="slozka-nadpis" v-html="addition.title"></div>
                            <div class="slozka-popis" v-html="addition.description"></div>
                        </div>
                    </div>
                </div>
                <div
                    class="view view-modelovy-pes-slozeni-krmiva view-id-modelovy_pes_slozeni_krmiva view-display-id-block view-dom-id-23b9e06b8988b95edec87e7e36ba185c">
                    <div class="view-content">
                        <div class="views-row views-row-3 views-row-odd views-row-last">
                            <!--<div class="views-field views-field-field-model-ikona-slozeni">-->
                            <!--<div class="field-content">-->
                            <!--<img typeof="foaf:Image"-->
                            <!--:src="getIconUrl('slozeni')"-->
                            <!--width="60" height="60" alt=""></div>-->
                            <!--</div>-->
                            <div class="views-field views-field-field-model-slozeni-nadpis">
                                <div class="field-content">Složení:</div>
                            </div>
                            <div class="views-field views-field-field-model-slozeni-popis">
                                <div class="field-content">
                                        <div class="composition-description" :class="{colapsed: !compositionExpanded}" v-html="composition"></div>
                                        <a @click="compositionExpanded = !compositionExpanded">zobrazit {{ compositionExpanded ? 'méně' : 'více' }}</a>
                                </div>
                            </div>
<!--                            <div class="views-field views-field-field-model-slozeni-veta">-->
<!--                                <div class="field-content">Nic víc opravdu není potřeba!-->
<!--                                    <a href="/nic-vic-neni-potreba" target="_blank">Proč?</a></div>-->
<!--                            </div>-->
                        </div>
                        <div v-if="selectedAdditionsBlocks.length > 0"
                             class="views-row views-row-3 views-row-odd views-row-last">
                            <!--<div class="views-field views-field-field-model-ikona-slozeni">-->
                            <!--<div class="field-content">-->
                            <!--<img typeof="foaf:Image"-->
                            <!--:src="getIconUrl('slozeni')"-->
                            <!--width="60" height="60" alt=""></div>-->
                            <!--</div>-->
                            <div class="views-field views-field-field-model-slozeni-nadpis">
                                <div class="field-content">Složení Pettime+:</div>
                            </div>
                            <div class="views-field views-field-field-model-slozeni-popis">
                                <div class="field-content">
                                    <p>
                                        <span v-for="(addition, key) in selectedAdditionsBlocks" :key="key"
                                              v-html="addition.composition"></span>
                                        <!-- <span :key="index" v-for="(composition, index) in topCompositionComponents">
                                            {{ composition.data.nazev_cj }}
                                            (<span v-text="round(Number(composition.p*100))"></span>%)
                                            <span v-if="index < (topCompositionComponents.length - 1)">,</span>
                                        </span> -->
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="views-row views-row-1 views-row-odd views-row-first">
                            <div class="views-field views-field-field-model-slozeni-popis">
                                <div class="field-content">
                                    <span :key="key" v-for="(alergie, key) in alergieFinalTexts">{{ alergie.desc_final }}</span>
                                    <span v-html="slozeniText"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="block-views-acdd7429a9a1746103e25993bb79fcaa" class="block block-views contextual-links-region">
            <h2>Analýza</h2>
        </div>
        <div id="block-views-bc7371bc08ec7790d0b483d2e808194b" class="block block-views contextual-links-region">
            <div class="content">
                <div
                    class="view view-modelovy-pes-analyza-prvek view-id-modelovy_pes_analyza_prvek view-display-id-block view-dom-id-ce0d6c32dbacad3f2acf37f751d2c6d3">
                    <div class="view-content">

                        <div :key="key" v-for="(value, name, key) in analysis"
                             class="views-row">
                            <div class="views-field views-field-field-model-slozka-ikona">
                                <div class="field-content">
                                    <img typeof="foaf:Image"
                                         :src="getIconUrl(value.name, 'icn-', '.svg')"
                                         width="50" height="50" alt="">
                                </div>
                            </div>
                            <div class="views-field views-field-field-model-slozka-procenta">
                                <div class="field-content">
                                    <span v-text="value.value + ' ' + value.unit"></span>
                                </div>
                            </div>
                            <div class="views-field views-field-field-model-slozka-nazev">
                                <div class="field-content">
                                    {{value.title}}
                                </div>
                            </div>
                        </div>
                        <div class="analyza-text" v-html="analyzaText"></div>
                    </div>
                </div>
            </div>
        </div>
        <div id="block-views-certifikaty-block" class="block block-views">
            <div class="content">
                <div
                    class="view view-certifikaty view-id-certifikaty view-display-id-block view-dom-id-0811530caefeb11cda25cd12b464a5b8">
                    <div class="view-content">
                        <div v-for="(certificate, key) in certificates" :key="key"
                             class="views-row views-row-1 views-row-odd views-row-first">
                            <div class="views-field views-field-field-certifikat-ikona">
                                <div class="field-content">
                                    <img typeof="foaf:Image" :src="getCertificateImageUrl(certificate.uri)" width="90"
                                         height="90" alt="">
                                </div>
                            </div>
                            <div class="views-field views-field-title">
                                <span class="field-content">{{certificate.title}}</span>
                            </div>
                            <div class="views-field views-field-field-certifikat-popis">
                                <div class="field-content">
                                    <div v-html="certificate.popis"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$store.state.mazlicek.krmivo.tydny.value !== 0" class="priobjednavka">
            <h2>Přiobjednejte si navíc Pettime+</h2>
            <div class="summary-subtitle">Postaráme se i o jeho duši</div>
            <div class="priobjednavka-obsah">
                <div :class="{disabled: selectedAdditions.indexOf(addition.id) < 0}" v-for="addition in additionalComponents" :key="addition.id">
                    <div class="addition-content-wrapper">
                        <div class="addition-icn">
                            <img :src="getIconUrlById(addition.id)" width="60" height="60"/>
                        </div>
                        <div class="addition-content">
                            <div class="addition-name">{{ addition.title }}</div>
                            <div class="addition-desc" v-html="addition.description"></div>
                            <div class="addition-price">
                                + {{ getAdditionPrice(addition.g_na_dk, addition.cena_za_g) }} Kč / den
                            </div>
                            <div class="button-wrapper">
                                <button v-if="selectedAdditions.indexOf(addition.id) >= 0"
                                        class="remove-addition button"
                                        @click="removeAddition(addition.id)">Odebrat
                                </button>
                                <button v-else :disabled="selectedAdditionsBlocks.length > 0" class="add-addition button" @click="addAddition(addition.id)">Přiobjednat
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="service in services" :key="service.id">
                    <div class="addition-content-wrapper">
                        <div class="addition-icn">
                            <img :src="getIconUrl('mineralni')" width="60" height="60"/>
                        </div>
                        <div class="addition-content">
                            <div class="addition-name">{{ service.title }}</div>
                            <div class="addition-desc" v-html="service.description"></div>
                            <div class="addition-price">+ {{ round(service.cena_za_den * tydnyKoeficient * 10) / 10
                                }} Kč / den
                            </div>
                            <div class="button-wrapper">
                                <button v-if="selectedServices.indexOf(service.id) >= 0"
                                        class="remove-addition button"
                                        @click="removeService(service.id)">Odebrat
                                </button>
                                <button v-else class="add-addition button" @click="addService(service.id)">Přiobjednat
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-button">
            <p>
            <span v-if="showTotalPrice" class="price-per-day">
                <span class="views-label views-label-field-model-cena-davky">
                    Cena / den:
                </span>
                <span class="cena-den">
                    {{(pricePerDay + '').replace('.', ',') }} Kč
                </span>
            </span>
                <a class="button">Přejít k objednávce</a></p>
        </div>

        <navigace
            :showPrev="true"
            :onClickPrev="prev"
        ></navigace>
    </div>
</template>

<script>
  import navigace from './Navigace'
  import filters from '../filters'
  import {apiSilex} from '../api'

  export default {
    components: {navigace},
    data: function () {
      return {
        mazlicek: this.$store.state.mazlicek,
        finalTexts: null,
        additional_info_header: null,
        tabsOpen: {
          0: true,
          1: true,
          2: true,
          3: true,
          4: true
        },
        hmotnostFinalText: null,
        pohybFinalText: null,
        slozky: {
          masova: {
            title: ''
          },
          prilohova: {
            title: ''
          },
          mineralni: {
            title: ''
          }
        },
        // feedData: this.$store.state.mazlicek.krmivo.feedData,
//                nutritionFinalText: this.$store.state.mazlicek.krmivo.feedData.feedRatio.nutritionalRequirements,
        alergieFinalTexts: null,
        additionalComponents: null, // toping (4. složka)
        selectedAdditions: this.$store.state.mazlicek.krmivo.selectedAdditions,
        grandTexts: {},
        naZkouskuVaha: 200,
        naZkouskuCena: 100,
        services: {},
        selectedServices: this.$store.state.mazlicek.krmivo.aditionalServices,
        compositionText: '',
        analyzaText: '',
        slozeniText: '',
        analysis: {},
        daily_cost_texts: null,
        certificates: {},
        velikost: null,
        compositionExpanded: false
      }
    },
    computed: {
      isDataLoading(){//weightFeedRatio, energyRatio, pricePerDay
        return this.weightFeedRatio && this.energyRatio && this.pricePerDay
      },
      showTotalPrice () {
        return this.mazlicek.krmivo.feedData.feedRatio && this.mazlicek.krmivo.feedData.feedRatio.showTotalPrice
      },
      typeRasa () {
        if (this.mazlicek.rasa.typ === 'app_rasa') {
          return this.mazlicekRasa.autocomplete.keyword
        } else if (this.mazlicek.rasa.typ == 'app_velikost' && this.velikost) {
          return this.velikost.title
        }
      },

      mazlicekRasa () {
        return this.mazlicek.rasa
      },
      sizePriceRatio () {
        return this.mazlicek.rasa.priceRatio
      },
      /**
       *  vrátí objekty toppingu, které jsou pridany ke krmivu
       */
      selectedAdditionsBlocks () {
        if (this.additionalComponents != null) {
          let blocks = this.additionalComponents.filter((item) => {
            return (typeof this.selectedAdditions.find((item2) => item2 == item.id) !== 'undefined')
          })
          return blocks
        }

        return []
      },
      composition () {
        if (this.mazlicek.krmivo.feedData.feedRatio === null) {
          return
        }

        const compositionTextUrl = '/mix_composition_text?id_mixu=' + this.mazlicek.krmivo.feedData.feedRatio.mix.id
        apiSilex.get(compositionTextUrl).then(
          response => {
            this.compositionText = response.data[0].text_slozeni_cj
          }
        )
        return this.compositionText
      },

      tydnyKoeficient () {
        const koeficient = this.$store.state.mazlicek.krmivo.tydny.data.koeficient

        return typeof koeficient != 'undefined' ? koeficient : ''
      },
      pricePerDay () {
        if (this.$store.state.mazlicek.krmivo.tydny.value == 0) {
          return this.naZkouskuCena
        }

        const pricePerDay = Number(this.$store.state.mazlicek.krmivo.cena.den)

        return Math.round(Number(pricePerDay) * 100) / 100
      },
      feedData () {
        // return this.$store.state.mazlicek.krmivo.feedData
        if (this.mazlicek.krmivo) {
          return this.mazlicek.krmivo.feedData
        }
      },
      energyRatio () {
        if (this.mazlicek.krmivo.feedData
          && this.mazlicek.krmivo.feedData.feedRatio) {
          return this.mazlicek.krmivo.feedData.feedRatio.energyRatio
        }
      },
      weightFeedRatio () {
        if (this.mazlicek.krmivo.feedData
          && this.mazlicek.krmivo.feedData.feedRatio) {
          return this.mazlicek.krmivo.feedData.feedRatio.weightFeedRatio
        }
      },
      originalWeightFeedRatio () {
        return this.mazlicek.krmivo.feedData.feedRatio.originalWeightFeedRatio
      },
      individualFeedWeight () {
        if (!this.mazlicek.krmivo.feedData.feedRatio) {
          return
        }

        const feedRatio = this.feedData.feedRatio

        return (feedRatio.individualFeedWeightCoeficient !== undefined) ? feedRatio.individualFeedWeightCoeficient : ''
      },
      totalPrice () {
        const weeks = Number(this.mazlicek.krmivo.tydny.data.pocetTydnu)

        return this.pricePerDay * 7 * weeks
      },
      dailyCostText () {
        if (this.daily_cost_texts != null) {
          let output = this.daily_cost_texts.filter((item) => item.min_price < this.pricePerDay && this.pricePerDay < item.max_price)
          return output[0]
        }

        return {}
      },
      weeksReadableValue () {
        const weekCount = this.mazlicek.krmivo.tydny.data.pocetTydnu

        return (weekCount == 1) ? 'týden' : (weekCount < 5) ? 'týdny' : 'týdnů'
      }
    },
    methods: {
      getAdditionPrice (g_na_dk, cena_za_g) {
        return Math.round(Number(this.originalWeightFeedRatio) / 100 * Number(g_na_dk) * Number(cena_za_g) * Number(this.sizePriceRatio) * this.tydnyKoeficient * 10) / 10
      },
      getCertificateImageUrl (uri) {
        const path = uri.replace('public:/', '')

        return '/sites/default/files/styles/certifikat/public' + path
      },
      getIconUrlById (id, extension = 'svg') {
        return id ? '/sites/default/files/aplikace/slozky/' + id + '.' + extension : ''
      },
      getIconUrl (name, namePrefix = 'icn-', extension = '.png') {
        return '/sites/default/files/aplikace/ikona/' + namePrefix + name + extension
      },
      prev: function () {
        this.$router.push({name: 'suroviny'})
      },

      changeTabsState (tbId) {
        this.tabsOpen[tbId] = this.tabsOpen[tbId] ? false : true
      },
      addAddition (additionId) {
        this.selectedAdditions.push(additionId)
        this.mazlicek.suroviny.slozky[4] = this.selectedAdditions.join(',')

        this.updateProduct()
      },
      removeAddition (additionId) {
        const additionIndex = this.selectedAdditions.indexOf(additionId)
        this.selectedAdditions.splice(additionIndex, 1)
        this.mazlicek.suroviny.slozky[4] = this.selectedAdditions.join(',')

        this.updateProduct()
      },
      addService (additionId) {
        this.selectedServices.push(additionId)

        this.updateProduct()
      },
      removeService (additionId) {
        const additionIndex = this.selectedServices.indexOf(additionId)
        this.selectedServices.splice(additionIndex, 1)

        this.updateProduct()
      },
      resetAllAditions () {
        this.resetAddition()
        this.resetService()
        this.updateProduct()
      },
      resetAddition () {
        this.$store.state.mazlicek.krmivo.selectedAdditions = []
        this.mazlicek.suroviny.slozky[4] = ''
      },
      resetService () {
        this.$store.state.mazlicek.krmivo.aditionalServices = []
      },
      updateProduct () {
        // console.log(this.mazlicek)
        this.$store.dispatch('updateProduct', this.mazlicek).then(response => {
          if (response.data.data.node && response.data.data.node.field_produkt_ref_suroviny.und && response.data.data.node.field_produkt_ref_suroviny.und[3] && response.data.data.node.field_produkt_ref_suroviny.und[3]['value']) {
            this.selectedAdditions = response.data.data.node.field_produkt_ref_suroviny.und[3]['value'].split(',')
          }
          if (response.data.data.node) {
            this.aditionalServices = []
            response.data.data.node.field_produkt_addition_services.und.forEach(
              item => this.aditionalServices.push(item.value)
            )
          }

          let krmivo = response.data.data.product.node
          this.$store.state.mazlicek.orderData.isFirstOrder = krmivo.order_data.is_first_order
          this.$store.state.mazlicek.orderData.firstOrderPrice = krmivo.order_data.first_order_price

          this.mazlicek.krmivo.feedData = response.data.data.feedData
          this.mazlicek.krmivo.cena.den = this.mazlicek.krmivo.feedData.feedRatio.totalPrice
          this.$store.commit('setMazlicek', this.mazlicek)

          this.$store.dispatch('updateProduct', this.mazlicek).then(response => {
            this.mazlicek.krmivo.feedData = response.data.data.feedData
            this.mazlicek.krmivo.cena.den = this.mazlicek.krmivo.feedData.feedRatio.totalPrice
            this.$store.commit('setMazlicek', this.mazlicek)
            this.$store.dispatch('updateProduct', this.mazlicek).then(response => {
              this.mazlicek.krmivo.feedData = response.data.data.feedData
              this.mazlicek.krmivo.cena.den = this.mazlicek.krmivo.feedData.feedRatio.totalPrice
              // console.log(this.mazlicek)
              this.$store.commit('setMazlicek', this.mazlicek)
            })
          })
        })
      },
      mountinMethod () {
        // if (this.mazlicek.petLoaded.value && this.mazlicek.productLoaded.value) {

        this.mazlicek.step.current = 9
        this.$cookies.set('lastVisitedStep', 9)
        this.mazlicek.hotovekrmivo.valid = true

        jQuery('html, body').animate({scrollTop: 0}, '500')

        const analysisUrl = '/analysis?id=' + this.mazlicek.krmivo.feedData.feedRatio.mix.id
        apiSilex.get(analysisUrl).then(
          response => {
            this.analysis = response.data
          }
        )

        apiSilex.get('/final_texts').then(
          response => {
            this.finalTexts = response.data
            this.finalTexts.forEach(item => {
              item.description = item.description.replace('[nazev]', this.mazlicek.jmeno.value)
              item.description = item.description.replace('[name]', this.mazlicek.jmeno.value)
            })
            this.mazlicek.finalTexts['finalObecneTexts'] = this.finalTexts
            this.$store.commit('setMazlicek', this.$store.state.mazlicek)
          }
        )

        apiSilex.get('/text_cena_den').then(
          response => {
            this.daily_cost_texts = response.data
          }
        )

        if (!this.mazlicek.jeStene) {
          let url = '/hmotnost?id=' + this.mazlicek.hmotnostkondice.kondice
          apiSilex.get(url).then(
            response => {
              this.hmotnostFinalText = response.data[0].desc_final
              this.hmotnostFinalText = this.hmotnostFinalText.replace('[nazev]', this.mazlicek.jmeno.value)
              this.hmotnostFinalText = this.hmotnostFinalText.replace('[name]', this.mazlicek.jmeno.value)
              this.mazlicek.finalTexts['hmotnostFinalText'] = this.hmotnostFinalText
              this.$store.commit('setMazlicek', this.$store.state.mazlicek)
            }
          )
          url = 'aktivita?id=' + this.mazlicek.pohyb.id
          apiSilex.get(url).then(
            response => {
              this.pohybFinalText = response.data[0].desc_final
              this.pohybFinalText = this.pohybFinalText.replace('[nazev]', this.mazlicek.jmeno.value)
              this.pohybFinalText = this.pohybFinalText.replace('[name]', this.mazlicek.jmeno.value)
              this.mazlicek.finalTexts['pohybFinalText'] = this.pohybFinalText
              this.$store.commit('setMazlicek', this.$store.state.mazlicek)
            }
          )
        }

        let url

        if (this.mazlicek.suroviny.slozky) {
          url = 'slozka?id=' + this.mazlicek.suroviny.slozky['1']
          apiSilex.get(url).then(
            response => {
              this.slozky.masova = response.data[0]
              if (this.slozky.masova.desc_final) {
                this.slozky.masova.desc_final = this.slozky.masova.desc_final.replace('[nazev]', this.mazlicek.jmeno.value)
                this.slozky.masova.desc_final = this.slozky.masova.desc_final.replace('[name]', this.mazlicek.jmeno.value)
              }
            }
          )
          url = 'slozka?id=' + this.mazlicek.suroviny.slozky['2']
          apiSilex.get(url).then(
            response => {
              this.slozky.prilohova = response.data[0]
              if (this.slozky.prilohova.desc_final) {
                this.slozky.prilohova.desc_final = this.slozky.prilohova.desc_final.replace('[nazev]', this.mazlicek.jmeno.value)
                this.slozky.prilohova.desc_final = this.slozky.prilohova.desc_final.replace('[name]', this.mazlicek.jmeno.value)
              }
            }
          )
        }
        // load topings
        const toppingsURL = '/topping'
        apiSilex.get(toppingsURL).then(res => {
          this.additionalComponents = res.data
          this.additionalComponents.forEach(addition => {
            addition.disable = false
          })
        })
        // load services
        const servicesUrl = '/services'
        apiSilex.get(servicesUrl).then(res => {
          this.services = res.data
        })
        if (this.mazlicek.alergie.alergeny.length) {
          url = '/alergen?id=' + this.mazlicek.alergie.alergeny.toString()
          apiSilex.get(url).then(
            response => {
              this.alergieFinalTexts = response.data
              this.alergieFinalTexts.forEach((item) => {
                item.desc_final.replace('[nazev]', this.mazlicek.jmeno.value)
                item.desc_final.replace('[name]', this.mazlicek.jmeno.value)
              })
              this.mazlicek.finalTexts['alergieFinalTexts'] = this.alergieFinalTexts
              this.$store.commit('setMazlicek', this.$store.state.mazlicek)
            }
          )
        }

        apiSilex.get('/velikost').then(
          response => {
            this.velikost = response.data.filter(
              item => item.id === this.mazlicek.rasa.velikost
            )[0]
          }
        )

        url = 'grand_texts?faze=' + this.mazlicek.narozeniny.value.format('DD-MM-YYYY') + '&condition=' + this.mazlicek.hmotnostkondice.kondice + '&activity=' + this.mazlicek.pohyb.id
        if (this.mazlicek.rasa.id) {
          url += '&brand=' + this.mazlicek.rasa.id
        }
        if (this.mazlicek.rasa.velikost) {
          url += '&size=' + this.mazlicek.rasa.velikost
        }
        if (this.mazlicek.alergie.alergeny.length) {
          url += '&alergeny=' + this.mazlicek.alergie.alergeny.toString()
        }
        apiSilex.get(url).then(
          response => {
            this.grandTexts = response.data
            this.grandTexts['pet-bread'].text = this.tokenReplace(response.data['pet-bread'].text, '[jméno]', this.mazlicek.jmeno.value)
            this.grandTexts['pet-live'].text_1 = this.tokenReplace(response.data['pet-live'].text_1, '[jméno]', this.mazlicek.jmeno.value)
            this.grandTexts['pet-live'].text_2 = this.tokenReplace(response.data['pet-live'].text_2, '[jméno]', this.mazlicek.jmeno.value)

            this.grandTexts['pet-bread'].text = this.tokenReplace(response.data['pet-bread'].text, '[plemeno]', this.typeRasa)
            this.grandTexts['pet-live'].text_1 = this.tokenReplace(response.data['pet-live'].text_1, '[plemeno]', this.typeRasa)
            this.grandTexts['pet-live'].text_2 = this.tokenReplace(response.data['pet-live'].text_2, '[plemeno]', this.typeRasa)
            this.mazlicek.grandTexts = response.data
            this.$store.commit('setMazlicek', this.$store.state.mazlicek)
          }
        )

        apiSilex.get('/certifikaty').then(
          response => {
            this.certificates = response.data
            // console.log(response)
          }
        )

        apiSilex.get('/additional_info/1').then(response => {
          this.additional_info_header = response.data
        }).catch(error => console.error(error))

        const compositionTextUrl = '/mix_composition_text?id_mixu=' + this.mazlicek.krmivo.feedData.feedRatio.mix.id
        apiSilex.get(compositionTextUrl).then(
          response => {
            this.compositionText = response.data[0].text_slozeni_cj
          }
        )

        const analyzaTextUrl = '/last_step?key_word=analyza'
        apiSilex.get(analyzaTextUrl).then(
          response => {
            this.analyzaText = response.data
          }
        )

        const slozeniTextUrl = '/last_step?key_word=slozeni'
        apiSilex.get(slozeniTextUrl).then(
          response => {
            this.slozeniText = response.data
          }
        )
      },
      tokenReplace (haystack, needle, replacement) {
        return haystack.split(needle).join(replacement)
      },
      round (value) {
        value = Number(value)
        return Math.round(value)
      }
      // }

    },
    mounted: function () {
      if (this.mazlicek.krmivo.nid != 0) {
        this.mountinMethod()
      }

    },
    watch: {
      'mazlicek.krmivo.tydny.value': {
        deep: true,
        handler: function (val) {
          if (val === 0) {
            this.resetAllAditions()
          }
        }
      },
      'mazlicek.productLoaded': {
        deep: true,
        handler: function (val) {
          if (val.value) {
            this.mountinMethod()
          }
        }
      }
//            'mazlicek.petLoaded': {
//                deep: true,
//                handler: function (val) {
//                    if (val.value)
//                        this.mountinMethod()
//                }
//            }
    }
  }
</script>
<style scoped>
    .composition-description {
        max-height: 500px;
        height: auto;
        overflow: hidden;
        transition: max-height .5s;
    }

    .composition-description.colapsed {
        max-height: 1.5em;
    }
</style>



// WEBPACK FOOTER //
// 10HotoveKrmivo.vue?68390d50